import { motion } from 'framer-motion';
import styled from 'styled-components';

import { styledReset } from '@pkg/primitives';

import { itemTransition, ItemVariant, itemVariants } from './CardGrid.motion';
import { tokens } from './tokens';

interface StyledCardGridProps {
    $compact?: boolean;
}

export const StyledCardGrid = styled.ul<StyledCardGridProps>`
    ${styledReset.list};
    --yat_card-grid-min-column: ${({ $compact }) => ($compact ? tokens.minColumn.compact : tokens.minColumn.default)}px;

    display: grid;
    gap: ${tokens.gap}px;
    grid-template-columns: repeat(auto-fill, minmax(var(--yat_card-grid-min-column), 1fr));

    // Need to target 'li' directly since CardTile doesn't use
    // StyledItem and is instead it's own motion.li component.
    > li {
        // Temporary solution to mitigate large card sizes.
        // This should be removed once we are able.
        max-width: ${tokens.itemMaxWidth}px;
    }
`;

// Currently not being used by `<CardTile />`.
export const StyledItem = styled(motion.li).attrs({
    variants: itemVariants,
    initial: ItemVariant.Initial,
    animate: ItemVariant.Show,
    exit: ItemVariant.Exit,
    transition: itemTransition,
    layout: true,
})`
    display: grid;
`;
